/**
* Projects Routes
*/
const ProjectsRoutes = {
  base: '/projects',
  addToProjects: '/customers/projects'
}

/**
* Invalidate Projects Cache
* @param {String} id - Optional Project ID
*/
export const invalidateProjects = {
  base() {
    return useInvalidateCache(ProjectsRoutes.base)
  },

  async all() {
    await this.base()
  }
}

/**
* useAddToProjects
* @param {Object} params 
* @returns {Promise<Object>}
*/
export function useAddToProjects(params) {
  return useCustomFetch(ProjectsRoutes.addToProjects, {
    method: 'POST',
    body: params
  })
}